import "../img/e-learning/e-learning-banner.png";
import "../img/homepage/employers-overlap.png";
import "../img/icons/apprentice-icon.jpg";
